module.exports = __webpack_public_path__ + "static/logos-teams-c2a4443ea842f0968a00f92093761385.png";